// import { useState, useMemo, useEffect, useRef } from "react";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { PROPERTY_TYPES, PKG_KEYS, buildSections, IC, iconKey, ROOM_ICONS } from "./quotationToolData";
// import Header from "../components/Header/header";
// import "./QuotationTool.css";

// /* =====================================================================
//    Dwellora Designs - Instant Quotation Tool
//    Needs:  npm install jspdf jspdf-autotable

//    NO PRICES LIVE IN THIS FILE. Package rates and every item price are
//    fetched from the CRM database (GET /api/quote-tool/pricing). The owner
//    edits them in Admin > Quotation tool pricing. If the CRM cannot be
//    reached the tool shows "Pricing unavailable" + Retry (no fallback prices).
//    ===================================================================== */

// // local host check (same convention as FurniturePlanner)
// const API_BASE_URL = (
//   process.env.NODE_ENV === "development"
//     ? process.env.REACT_APP_ADMIN_API_BASE_URL ||
//       process.env.REACT_APP_API_BASE_URL ||
//       "http://localhost:3005"
//     : process.env.REACT_APP_API_BASE_URL || ""
// ).replace(/\/$/, "");

// const PRICING_URL = `${API_BASE_URL}/api/quote-tool/pricing`;

// const BRAND = "Dwellora Designs";
// const TAGLINE = "Interior Design Quotation";
// const CONTACT = "dwelloradesigns.com"; // shown in PDF footer
// // Optional: URL to receive client details (Google Apps Script / Formspree / your server). Leave empty to only generate the PDF.
// const WEBHOOK_URL = "";

// // Package card images. CRM ke image_url / image field ko priority milti hai,
// // warna ye public folder wale paths use hote hain. Apni images yahan rakho:
// // public/images/packages/basic.jpg, premium.jpg, luxury.jpg
// const PACKAGE_IMAGES = {
//   basic: `${process.env.PUBLIC_URL || ""}/images/packages/basic.jpg`,
//   premium: `${process.env.PUBLIC_URL || ""}/images/packages/premium.jpg`,
//   luxury: `${process.env.PUBLIC_URL || ""}/images/packages/luxury.jpg`,
// };

// const STEP_NAMES = ["Property & Area", "Package", "Details", "Your Info"];

// const inr = (n) => "\u20B9" + Math.round(n).toLocaleString("en-IN");
// const rs = (n) => "Rs. " + Math.round(n).toLocaleString("en-IN");
// const keyOf = (sec, it) => sec.id + "." + it.id;

// /* Item definitions come from quotationToolData.js; prices come from the CRM.
//    An item without a CRM price (or switched to Hidden) is not shown. */
// function makeSections(pricing, beds, typeId) {
//   if (!pricing) return [];
//   const big = ["bungalow", "penthouse", "other"].includes(typeId);
//   return buildSections(beds, big)
//     .map((sec) => ({
//       ...sec,
//       items: sec.items
//         .map((it) => {
//           const crm = pricing.items[keyOf(sec, it)];
//           if (!crm) return null;
//           return {
//             ...it,
//             price: Number(crm.price),
//             inc: Array.isArray(crm.included_in) ? crm.included_in : it.inc,
//           };
//         })
//         .filter(Boolean),
//     }))
//     .filter((sec) => sec.items.length);
// }

// function defaultSelection(sections, pkg) {
//   const picked = new Set();
//   if (!pkg) return picked;
//   sections.forEach((sec) =>
//     sec.items.forEach((it) => {
//       if (it.inc.includes(pkg)) picked.add(keyOf(sec, it));
//     })
//   );
//   return picked;
// }

// const incList = (sec, pkg) => sec.items.filter((it) => it.inc.includes(pkg));
// const optList = (sec, pkg) => sec.items.filter((it) => !it.inc.includes(pkg));
// const itemQty = (sec, it) => it.mult || sec.mult || 1;
// const itemQtyLabel = (sec, it) => it.multLabel || sec.multLabel || "units";
// const itemAmt = (sec, it) => it.price * itemQty(sec, it);
// const roomAmt = (sec, pkg) => incList(sec, pkg).reduce((a, it) => a + itemAmt(sec, it), 0);

// function noteText(sec, it) {
//   const qty = itemQty(sec, it);
//   const parts = [];
//   if (it.size) parts.push("Size: " + it.size + " (L x W)");
//   if (it.note) parts.push(it.note);
//   if (qty > 1) parts.push(qty + " " + itemQtyLabel(sec, it) + " x " + inr(it.price));
//   return parts.join(" \u00B7 ");
// }

// function Icon({ name, forceKey }) {
//   const k = forceKey || iconKey(name);
//   return (
//     <svg
//       viewBox="0 0 64 64"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       aria-hidden="true"
//       dangerouslySetInnerHTML={{ __html: IC[k] }}
//     />
//   );
// }

// function PackageImage({ src, alt }) {
//   const [failed, setFailed] = useState(false);
//   return (
//     <div className="qt-pimg">
//       {src && !failed ? (
//         <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
//       ) : (
//         <div className="qt-pimg-fb">{alt}</div>
//       )}
//     </div>
//   );
// }

// function IncludedCard({ sec, it, selected, onToggle }) {
//   const amt = itemAmt(sec, it);
//   const note = noteText(sec, it);
//   return (
//     <div className={`qt-icard ${selected ? "" : "qt-off"}`}>
//       <div className="qt-pic"><Icon name={it.name} /></div>
//       <div className="qt-nm">
//         {it.name}
//         {note && <small>{note}</small>}
//       </div>
//       <div className="qt-side">
//         <span className="qt-price">{inr(amt)}</span>
//         {selected ? (
//           <button type="button" className="qt-tbtn qt-rm" onClick={() => onToggle(keyOf(sec, it))}>
//             Remove &middot; &minus;{inr(amt)}
//           </button>
//         ) : (
//           <button type="button" className="qt-tbtn qt-un" onClick={() => onToggle(keyOf(sec, it))}>
//             Undo &middot; +{inr(amt)}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// function AddonCard({ sec, it, selected, onToggle }) {
//   const amt = itemAmt(sec, it);
//   const note = noteText(sec, it);
//   return (
//     <div className={`qt-acard ${selected ? "qt-on" : ""}`}>
//       <div className="qt-a-img"><Icon name={it.name} /></div>
//       <div className="qt-a-info">
//         <div className="qt-nm">
//           {it.name}
//           {note && <small>{note}</small>}
//         </div>
//       </div>
//       <div className="qt-a-bot">
//         <span className="qt-a-price">{inr(amt)}</span>
//         {selected ? (
//           <button type="button" className="qt-tbtn qt-un" onClick={() => onToggle(keyOf(sec, it))}>
//             &#10003; Added &middot; Undo
//           </button>
//         ) : (
//           <button type="button" className="qt-tbtn qt-ad" onClick={() => onToggle(keyOf(sec, it))}>
//             + Add
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// function PriceBreakdown({ title, amount, items, action, onItem, onRoom }) {
//   return (
//     <div className="qt-pb-col">
//       <h4><span>{title}</span><span>{title === "Added" ? "+" : "\u2212"}{inr(amount)}</span></h4>
//       {items.length ? (
//         <ul>{items.map((record) => (
//           <li key={record.room ? `room-${record.sec.id}` : keyOf(record.sec, record.it)}>
//             <span className="qt-l"><b>{record.room ? record.sec.name : record.it.name}</b><small>{record.room ? "Whole room" : record.sec.name}</small></span>
//             <span className="qt-a">{title === "Added" ? "+" : "\u2212"}{inr(record.amt)}</span>
//             <button type="button" className="qt-pb-undo" onClick={() => record.room ? onRoom(record.sec.id) : onItem(keyOf(record.sec, record.it))}>{action}</button>
//           </li>
//         ))}</ul>
//       ) : <div className="qt-pb-none">Nothing {title === "Added" ? "added" : "removed"} yet.</div>}
//     </div>
//   );
// }

// export default function QuotationTool() {
//   const [pricing, setPricing] = useState(null);
//   const [pricingState, setPricingState] = useState("loading"); // loading | ready | error

//   const [step, setStep] = useState(1);
//   const [typeId, setTypeId] = useState(null);
//   const [otherName, setOtherName] = useState("");
//   const [beds, setBeds] = useState(2);
//   const [area, setArea] = useState("");
//   const [pkg, setPkg] = useState(null);
//   const [selected, setSelected] = useState(new Set());
//   const [removedRooms, setRemovedRooms] = useState(new Set());
//   const [activeSec, setActiveSec] = useState(null);
//   const [client, setClient] = useState({ name: "", phone: "", email: "", address: "" });
//   const [quoteNo, setQuoteNo] = useState("");
//   const [quoteDate, setQuoteDate] = useState(null);
//   const [error, setError] = useState("");
//   const [priceBreakdownOpen, setPriceBreakdownOpen] = useState(false);
//   const chipbarRef = useRef(null);
//   const addonsRef = useRef(null);

//   /* ---------- load prices from the CRM ---------- */
//   const loadPricing = async () => {
//     setPricingState("loading");
//     try {
//       const response = await fetch(PRICING_URL, { cache: "no-store" });
//       const payload = await response.json();
//       if (!response.ok || !payload?.success || !payload.data) throw new Error("Pricing unavailable");
//       const data = payload.data;
//       if (!Array.isArray(data.packages) || !data.packages.length || !data.items) throw new Error("Pricing unavailable");
//       setPricing(data);
//       setPricingState("ready");
//     } catch (err) {
//       setPricing(null);
//       setPricingState("error");
//     }
//   };

//   useEffect(() => {
//     loadPricing();
//   }, []); // eslint-disable-line react-hooks/exhaustive-deps

//   const settings = pricing?.settings || {};
//   const minArea = Number(settings.min_area) || 100;
//   const validityDays = Number(settings.validity_days) || 15;
//   const gstNote = settings.gst_note || "GST extra as applicable.";
//   const packages = pricing?.packages || [];
//   const pkgData = packages.find((p) => p.code === pkg) || null;
//   const pkgRate = pkgData ? Number(pkgData.rate_per_sqft) : 0;

//   const sections = useMemo(() => makeSections(pricing, beds, typeId), [pricing, beds, typeId]);

//   const propertyLabel = () => {
//     const t = PROPERTY_TYPES.find((p) => p.id === typeId);
//     if (!t) return "-";
//     if (t.id === "other") return "Other" + (otherName ? " (" + otherName + ")" : "");
//     return t.unit ? t.label + " " + t.unit : t.label;
//   };

//   /* ---------- calculation: base + added - removed - removed rooms ---------- */
//   const calc = useMemo(() => {
//     const areaNum = parseFloat(area) || 0;
//     const base = areaNum * pkgRate;
//     const added = [];
//     const removed = [];
//     const rooms = [];
//     sections.forEach((sec) => {
//       if (removedRooms.has(sec.id)) {
//         rooms.push({ sec, amt: roomAmt(sec, pkg) });
//         return;
//       }
//       sec.items.forEach((it) => {
//         const qty = itemQty(sec, it);
//         const rec = { sec, it, qty, amt: it.price * qty };
//         const isDefault = it.inc.includes(pkg);
//         const isSel = selected.has(keyOf(sec, it));
//         if (isSel && !isDefault) added.push(rec);
//         if (!isSel && isDefault) removed.push(rec);
//       });
//     });
//     const addSum = added.reduce((a, r) => a + r.amt, 0);
//     const remSum = removed.reduce((a, r) => a + r.amt, 0);
//     const roomSum = rooms.reduce((a, r) => a + r.amt, 0);
//     const total = Math.max(0, base + addSum - remSum - roomSum);
//     return { area: areaNum, rate: pkgRate, base, added, removed, rooms, addSum, remSum, roomSum, total };
//   }, [sections, selected, removedRooms, pkg, area, pkgRate]);

//   const ready = Boolean(pkg && calc.area);
//   const removedTotal = calc.remSum + calc.roomSum;

//   /* ---------- actions ---------- */
//   const chooseType = (t) => {
//     const nextBeds = t.id !== "other" ? t.beds : typeId !== "other" ? 2 : beds;
//     setTypeId(t.id);
//     setBeds(nextBeds);
//     setSelected(defaultSelection(makeSections(pricing, nextBeds, t.id), pkg));
//     setRemovedRooms(new Set());
//     setError("");
//   };

//   const changeOtherBeds = (value) => {
//     const n = Math.min(10, Math.max(1, parseInt(value, 10) || 1));
//     setBeds(n);
//     setSelected(defaultSelection(makeSections(pricing, n, typeId), pkg));
//     setRemovedRooms(new Set());
//   };

//   // package select hote hi seedha next step (Details) par jata hai
//   const choosePackage = (code) => {
//     if (pkg !== code) {
//       setPkg(code);
//       setSelected(defaultSelection(sections, code));
//       setRemovedRooms(new Set());
//     }
//     setError("");
//     setStep(3);
//   };

//   const toggleItem = (key) => {
//     setSelected((current) => {
//       const next = new Set(current);
//       if (next.has(key)) next.delete(key);
//       else next.add(key);
//       return next;
//     });
//   };

//   const toggleRoom = (id) => {
//     const sec = sections.find((s) => s.id === id);
//     if (!sec) return;
//     const nextRemoved = new Set(removedRooms);
//     const nextSelected = new Set(selected);
//     if (nextRemoved.has(id)) {
//       nextRemoved.delete(id);
//       incList(sec, pkg).forEach((it) => nextSelected.add(keyOf(sec, it)));
//     } else {
//       nextRemoved.add(id);
//       sec.items.forEach((it) => nextSelected.delete(keyOf(sec, it)));
//     }
//     setRemovedRooms(nextRemoved);
//     setSelected(nextSelected);
//   };

//   const jumpTo = (id) => {
//     setActiveSec(id);
//     if (addonsRef.current) addonsRef.current.scrollTop = 0;
//     const target = document.getElementById("qt-dsec-" + id);
//     if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   const goNext = () => {
//     if (step === 1) {
//       if (!typeId) return setError("Please select a property type.");
//       if (typeId === "other" && !otherName.trim()) return setError("Please enter your property type.");
//       const a = parseFloat(area);
//       if (!a || a < minArea) return setError(`Please enter carpet area (minimum ${minArea} sqft).`);
//     }
//     if (step === 2 && !pkg) return setError("Please select a package.");
//     setError("");
//     setStep(step + 1);
//   };

//   const goBack = () => {
//     setError("");
//     setStep(Math.max(1, step - 1));
//   };

//   const submitQuote = () => {
//     const phone = client.phone.replace(/\D/g, "").replace(/^91(?=\d{10}$)/, "");
//     if (!client.name.trim()) return setError("Please enter your name.");
//     if (!/^[6-9]\d{9}$/.test(phone)) return setError("Please enter a valid 10-digit mobile number.");
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(client.email.trim())) return setError("Please enter a valid email address.");
//     if (client.address.trim().length < 5) return setError("Please enter your property address.");

//     const d = new Date();
//     const ymd = d.getFullYear().toString() + String(d.getMonth() + 1).padStart(2, "0") + String(d.getDate()).padStart(2, "0");
//     const number = "DD-" + ymd + "-" + String(Math.floor(1000 + Math.random() * 9000));
//     setQuoteDate(d);
//     setQuoteNo(number);
//     setError("");

//     if (WEBHOOK_URL) {
//       const payload = {
//         quoteNo: number, date: d.toISOString(),
//         client, property: propertyLabel(), bedrooms: beds,
//         carpetAreaSqft: calc.area, package: pkgData.name, ratePerSqft: calc.rate,
//         baseAmount: calc.base, addedAmount: calc.addSum, removedAmount: calc.remSum + calc.roomSum, totalEstimate: calc.total,
//         removedRooms: calc.rooms.map((r) => ({ room: r.sec.name, amount: r.amt })),
//         added: calc.added.map((r) => ({ section: r.sec.name, item: r.it.name, amount: r.amt })),
//         removed: calc.removed.map((r) => ({ section: r.sec.name, item: r.it.name, amount: r.amt })),
//       };
//       fetch(WEBHOOK_URL, {
//         method: "POST", mode: "no-cors",
//         headers: { "Content-Type": "text/plain;charset=utf-8" },
//         body: JSON.stringify(payload),
//       }).catch(() => {});
//     }
//     setStep(5);
//   };

//   const restart = () => {
//     setStep(1);
//     setTypeId(null);
//     setOtherName("");
//     setBeds(2);
//     setArea("");
//     setPkg(null);
//     setSelected(new Set());
//     setRemovedRooms(new Set());
//     setClient({ name: "", phone: "", email: "", address: "" });
//     setQuoteNo("");
//     setQuoteDate(null);
//     setError("");
//     setPriceBreakdownOpen(false);
//   };

//   /* ---------- scroll to top on step change ---------- */
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [step]);

//   /* ---------- details step: keep the active room tab in sync with scrolling ---------- */
//   useEffect(() => {
//     if (step !== 3 || !sections.length) return undefined;
//     if (!sections.some((s) => s.id === activeSec)) setActiveSec(sections[0].id);
//     let raf = 0;
//     const spy = () => {
//       raf = 0;
//       let current = sections[0].id;
//       sections.forEach((sec) => {
//         const el = document.getElementById("qt-dsec-" + sec.id);
//         if (el && el.getBoundingClientRect().top <= 170) current = sec.id;
//       });
//       setActiveSec(current);
//     };
//     const onScroll = () => {
//       if (!raf) raf = requestAnimationFrame(spy);
//     };
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => {
//       window.removeEventListener("scroll", onScroll);
//       if (raf) cancelAnimationFrame(raf);
//     };
//   }, [step, sections, activeSec]);

//   useEffect(() => {
//     const bar = chipbarRef.current;
//     if (!bar) return;
//     const on = bar.querySelector(".qt-chip.qt-on");
//     if (on) bar.scrollTo({ left: on.offsetLeft - bar.clientWidth / 2 + on.offsetWidth / 2, behavior: "smooth" });
//   }, [activeSec]);

//   const addonSec = sections.find((s) => s.id === activeSec) || sections[0];

//   /* ---------- PDF ---------- */
//   const generatePDF = () => {
//     const doc = new jsPDF({ unit: "mm", format: "a4" });
//     const W = doc.internal.pageSize.getWidth();
//     const H = doc.internal.pageSize.getHeight();
//     const GOLD = [201, 161, 74], INK = [17, 17, 17], GREY = [245, 245, 245];
//     const d = quoteDate || new Date();
//     const dateStr = d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

//     // Header band
//     doc.setFillColor(...INK); doc.rect(0, 0, W, 30, "F");
//     doc.setTextColor(255, 255, 255); doc.setFont("times", "bold"); doc.setFontSize(22);
//     doc.text(BRAND, 14, 14);
//     doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...GOLD);
//     doc.text(TAGLINE, 14, 21);
//     doc.setTextColor(255, 255, 255); doc.setFontSize(9);
//     doc.text("Quotation No: " + quoteNo, W - 14, 13, { align: "right" });
//     doc.text("Date: " + dateStr, W - 14, 19, { align: "right" });
//     doc.text("Valid for " + validityDays + " days", W - 14, 25, { align: "right" });

//     // Client + project blocks
//     doc.setTextColor(...INK);
//     let y = 40;
//     doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(110, 110, 110);
//     doc.text("PREPARED FOR", 14, y); doc.text("PROJECT", W / 2 + 4, y);
//     doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...INK);
//     const left = [client.name, "Mobile: " + client.phone, "Email: " + client.email]
//       .concat(doc.splitTextToSize("Address: " + client.address, W / 2 - 20));
//     const right = ["Property: " + propertyLabel(),
//       "Carpet area: " + calc.area.toLocaleString("en-IN") + " sqft",
//       "Package: " + pkgData.name + " (" + rs(calc.rate) + " / sqft)"];
//     doc.text(left, 14, y + 6);
//     doc.text(doc.splitTextToSize(right.join("\n"), W / 2 - 18), W / 2 + 4, y + 6);
//     y += 6 + Math.max(left.length, right.length) * 5 + 4;

//     // Package specifications
//     autoTable(doc, {
//       startY: y, head: [["Package specification - " + pkgData.name, ""]], body: pkgData.specs,
//       theme: "grid", margin: { left: 14, right: 14 },
//       styles: { fontSize: 8.5, cellPadding: 1.8, lineColor: [228, 228, 228], lineWidth: 0.2, textColor: INK },
//       headStyles: { fillColor: GREY, textColor: INK, fontStyle: "bold" },
//       columnStyles: { 0: { cellWidth: 55, fontStyle: "bold" } },
//     });
//     y = doc.lastAutoTable.finalY + 6;

//     // Items table
//     const body = [];
//     sections.forEach((sec) => {
//       const rows = [];
//       if (removedRooms.has(sec.id)) {
//         rows.push(["Entire room removed from scope", "Removed", "- " + rs(roomAmt(sec, pkg))]);
//       } else {
//         sec.items.forEach((it) => {
//           const qty = itemQty(sec, it);
//           const amt = it.price * qty;
//           const isDef = it.inc.includes(pkg);
//           const isSel = selected.has(keyOf(sec, it));
//           const nm = it.name + (it.size ? " (" + it.size + ")" : "") + (it.note ? " (" + it.note + ")" : "") + (qty > 1 ? " (x" + qty + " " + itemQtyLabel(sec, it) + ")" : "");
//           if (isSel && isDef) rows.push([nm, "Included", "In package"]);
//           else if (isSel && !isDef) rows.push([nm, "Added", "+ " + rs(amt)]);
//           else if (!isSel && isDef) rows.push([nm, "Removed", "- " + rs(amt)]);
//         });
//       }
//       if (rows.length) {
//         body.push([{ content: sec.name, colSpan: 3, styles: { fillColor: GREY, fontStyle: "bold", textColor: INK } }]);
//         rows.forEach((r) => body.push(r));
//       }
//     });
//     autoTable(doc, {
//       startY: y, head: [["Item", "Status", "Amount"]], body,
//       theme: "grid", margin: { left: 14, right: 14 },
//       styles: { fontSize: 9, cellPadding: 2.2, lineColor: [228, 228, 228], lineWidth: 0.2, textColor: INK },
//       headStyles: { fillColor: INK, textColor: 255 },
//       columnStyles: { 0: { cellWidth: "auto" }, 1: { cellWidth: 26 }, 2: { cellWidth: 40, halign: "right" } },
//       didParseCell: (data) => {
//         if (data.section === "head" && data.column.index === 2) data.cell.styles.halign = "right";
//         if (data.section === "body" && data.column.index > 0) {
//           const st = data.row.raw[1];
//           if (st === "Added") data.cell.styles.fontStyle = "bold";
//           if (st === "Removed") data.cell.styles.textColor = [130, 130, 130];
//         }
//       },
//     });

//     // Totals
//     let ty = doc.lastAutoTable.finalY + 8;
//     if (ty > H - 70) { doc.addPage(); ty = 20; }
//     const trows = [
//       ["Base package (" + calc.area.toLocaleString("en-IN") + " sqft x " + rs(calc.rate) + ")", rs(calc.base)],
//       ["Added items (" + calc.added.length + ")", "+ " + rs(calc.addSum)],
//       ["Removed items (" + calc.removed.length + ")", "- " + rs(calc.remSum)],
//     ];
//     if (calc.rooms.length) trows.push(["Removed rooms (" + calc.rooms.length + ")", "- " + rs(calc.roomSum)]);
//     trows.push(["TOTAL ESTIMATE", rs(calc.total)]);
//     autoTable(doc, {
//       startY: ty, body: trows, theme: "plain", margin: { left: W / 2 - 30, right: 14 },
//       styles: { fontSize: 10, cellPadding: 2.4, textColor: INK },
//       columnStyles: { 0: { cellWidth: "auto" }, 1: { halign: "right", cellWidth: 36 } },
//       didParseCell: (data) => {
//         if (data.row.index === trows.length - 1) {
//           data.cell.styles.fontStyle = "bold"; data.cell.styles.fontSize = 12;
//           data.cell.styles.fillColor = GREY;
//         }
//       },
//     });

//     // Terms
//     let ky = doc.lastAutoTable.finalY + 10;
//     if (ky > H - 45) { doc.addPage(); ky = 20; }
//     doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(...INK);
//     doc.text("TERMS & NOTES", 14, ky);
//     doc.setFont("helvetica", "normal"); doc.setFontSize(8.5); doc.setTextColor(80, 80, 80);
//     const terms = [
//       "1. This is an approximate estimate based on the details provided. Final pricing may be slightly higher or lower depending on accurate room sizing, as verified by our team after site measurement.",
//       "2. " + gstNote,
//       "3. Quotation valid for " + validityDays + " days from the date of issue.",
//       "4. Material brands, finishes and specifications will be finalised in the design agreement.",
//     ];
//     doc.text(doc.splitTextToSize(terms.join("\n"), W - 28), 14, ky + 6);

//     // Footer on each page
//     const pages = doc.getNumberOfPages();
//     for (let i = 1; i <= pages; i++) {
//       doc.setPage(i);
//       doc.setDrawColor(...GOLD); doc.setLineWidth(0.4); doc.line(14, H - 14, W - 14, H - 14);
//       doc.setFontSize(8); doc.setTextColor(120, 120, 120);
//       doc.text(BRAND + "  |  " + CONTACT, 14, H - 9);
//       doc.text("Page " + i + " of " + pages, W - 14, H - 9, { align: "right" });
//     }
//     const safe = (client.name || "Client").replace(/[^a-z0-9]+/gi, "_");
//     doc.save("Dwellora_Quotation_" + safe + "_" + quoteNo + ".pdf");
//   };

//   const wide = step === 3 && pricingState === "ready";
//   const packageStep = step === 2;

//   return (
//     <>
//       <Header />
//       <div className="qt">
//       {step === 3 && (
//         <div className="qt-pricebar">
//           <div className="qt-pb-in">
//             <div className="qt-pb-ctx">
//               <div className="qt-pb-brand">Dwellora</div>
//               <div className="qt-pb-meta">{propertyLabel()} &middot; {calc.area ? calc.area.toLocaleString("en-IN") + " sqft" : "-"} &middot; {pkgData?.name || "-"}</div>
//             </div>
//             <div className="qt-pb-stats" aria-label="Price build-up">
//               <div className="qt-pb-stat"><span>Base<em> package</em></span><b>{ready ? inr(calc.base) : "-"}</b></div><div className="qt-pb-op">+</div>
//               <div className="qt-pb-stat"><span>Added<em> ({calc.added.length})</em></span><b>{ready ? inr(calc.addSum) : "-"}</b></div><div className="qt-pb-op">&minus;</div>
//               <div className="qt-pb-stat qt-rem"><span>Removed<em> ({calc.removed.length + calc.rooms.length})</em></span><b>{ready ? inr(removedTotal) : "-"}</b></div><div className="qt-pb-op qt-eq">=</div>
//             </div>
//             <div className="qt-pb-total">
//               <div className="qt-pb-tot"><span>Total<em> estimate</em></span><b>{ready ? inr(calc.total) : "-"}</b></div>
//               <button type="button" className="qt-pb-btn" onClick={() => setPriceBreakdownOpen((open) => !open)} aria-expanded={priceBreakdownOpen}>Breakdown <i>&#9662;</i></button>
//             </div>
//             {priceBreakdownOpen && (
//               <div className="qt-pb-drop"><div className="qt-pb-drop-in">
//                 <p className="qt-pb-eq"><b>{propertyLabel()}</b> &middot; {calc.area ? calc.area.toLocaleString("en-IN") : "-"} sqft &times; {inr(calc.rate)} ({pkgData?.name || "-"}) = <b>{inr(calc.base)}</b></p>
//                 <div className="qt-pb-cols">
//                   <PriceBreakdown title="Added" amount={calc.addSum} items={calc.added} action="Undo" onItem={toggleItem} />
//                   <PriceBreakdown title="Removed" amount={removedTotal} items={[...calc.rooms.map((r) => ({ ...r, room: true })), ...calc.removed]} action="Restore" onItem={toggleItem} onRoom={toggleRoom} />
//                 </div>
//                 <div className="qt-pb-foot">Approximate estimate. Final price may vary slightly based on accurate room sizing. {gstNote}</div>
//               </div></div>
//             )}
//           </div>
//         </div>
//       )}
//       <div className={`qt-wrap ${wide ? "qt-wide" : ""}`}>
//         <header className="qt-top">
//           <div className="qt-pagehead">
//             <h1 className="qt-ptitle">Get Your Instant Quotation</h1>
//             <p className="qt-ptagline">Free estimate &middot; Takes 2 minutes &middot; No obligation</p>
//           </div>
//           {step === 3 && (
//             <button type="button" className="qt-backlink" onClick={goBack}>&larr; Change package</button>
//           )}
//         </header>

//         <div className="qt-progress">
//           {STEP_NAMES.map((name, i) => {
//             const k = i + 1;
//             const cls = step > 4 || k < step ? "qt-done" : k === step ? "qt-now" : "";
//             return (
//               <div className={`qt-pstep ${cls}`} key={name}>
//                 <i />
//                 {k}. {name}
//               </div>
//             );
//           })}
//         </div>

//         {pricingState !== "ready" && (
//           <div className="qt-grid">
//             <main className="qt-card">
//               {pricingState === "loading" && (
//                 <>
//                   <h2>Loading prices&hellip;</h2>
//                   <p className="qt-lead">Please wait a moment while we fetch the latest rates.</p>
//                 </>
//               )}
//               {pricingState === "error" && (
//                 <>
//                   <h2>Pricing unavailable</h2>
//                   <p className="qt-lead">We could not load the latest prices right now. Please check your connection and try again.</p>
//                   <button type="button" className="qt-btn qt-p" onClick={loadPricing}>Retry</button>
//                 </>
//               )}
//             </main>
//           </div>
//         )}

//         {pricingState === "ready" && (
//           <div className={`qt-grid ${wide ? "qt-g3" : ""} ${packageStep ? "qt-g1" : ""}`}>
//             <main className="qt-card">
//               {/* ---------------- STEP 1: property & area ---------------- */}
//               {step === 1 && (
//                 <>
//                   <h2>Your property</h2>
//                   <p className="qt-lead">Choose your property type and enter the carpet area.</p>
//                   <label className="qt-f" style={{ marginTop: 0 }}>1. Choose your property type</label>
//                   <div className="qt-opts">
//                     {PROPERTY_TYPES.map((p) => (
//                       <button
//                         type="button"
//                         key={p.id}
//                         className={`qt-opt ${typeId === p.id ? "qt-sel" : ""}`}
//                         onClick={() => chooseType(p)}
//                       >
//                         <b>{p.label}</b>
//                         {p.unit && <span className="qt-u">{p.unit}</span>}
//                         {p.id === "other" && <small>Specify below</small>}
//                       </button>
//                     ))}
//                   </div>
//                   {typeId === "other" && (
//                     <div className="qt-two">
//                       <div>
//                         <label className="qt-f">Property type (e.g. Villa, Duplex, Office)</label>
//                         <input type="text" value={otherName} placeholder="Type property name" onChange={(e) => setOtherName(e.target.value)} />
//                       </div>
//                       <div>
//                         <label className="qt-f">Number of bedrooms</label>
//                         <input type="number" min="1" max="10" value={beds} onChange={(e) => changeOtherBeds(e.target.value)} />
//                       </div>
//                     </div>
//                   )}
//                   <label className="qt-f" style={{ marginTop: 24 }}>2. Carpet area (sqft)</label>
//                   <input type="number" min={minArea} inputMode="numeric" value={area} placeholder="e.g. 1200" onChange={(e) => setArea(e.target.value)} />
//                   <div className="qt-hint">Minimum {minArea} sqft. Exact area will be confirmed after site measurement.</div>
//                   <div className="qt-err">{error}</div>
//                   <div className="qt-nav qt-nav-center">
//                     <button type="button" className="qt-btn qt-p" onClick={goNext}>Next &rarr;</button>
//                   </div>
//                 </>
//               )}

//               {/* ---------------- STEP 2: package ---------------- */}
//               {step === 2 && (
//                 <>
//                   <h2>Select your package</h2>
//                   <p className="qt-lead">Choose the package that suits you best. Rates are per sq ft.</p>
//                   <div className="qt-pkgs">
//                     {packages.map((p) => (
//                       <button
//                         type="button"
//                         key={p.code}
//                         className={`qt-pkg ${pkg === p.code ? "qt-sel" : ""}`}
//                         onClick={() => choosePackage(p.code)}
//                       >
//                         {Boolean(p.popular) && <span className="qt-badge">Most popular</span>}
//                         <PackageImage src={p.image_url || p.image || PACKAGE_IMAGES[p.code]} alt={p.name} />
//                         <h3 className="qt-pill">{p.name}</h3>
//                         <div className="qt-rate">{inr(Number(p.rate_per_sqft))} <small>/ sq ft</small></div>
//                         <small className="qt-ptag">{p.tag}</small>
//                         <dl className="qt-specs">
//                           {(p.specs || []).map((spec) => (
//                             <div key={spec[0]}>
//                               <dt>{spec[0]}</dt>
//                               <dd>{spec[1]}</dd>
//                             </div>
//                           ))}
//                         </dl>
//                         <div className="qt-ptotal">
//                           <span>Total Estimate</span>
//                           <b>{inr((parseFloat(area) || 0) * Number(p.rate_per_sqft))}</b>
//                         </div>
//                         <span className="qt-pselect">{pkg === p.code ? p.name + " selected \u2713" : "Select " + p.name}</span>
//                       </button>
//                     ))}
//                   </div>
//                   <div className="qt-pnote">Civil work and electrical work are priced separately and do not change with the package.</div>
//                   <div className="qt-err">{error}</div>
//                   <div className="qt-nav">
//                     <button type="button" className="qt-btn qt-s" onClick={goBack}>&larr; Back</button>
//                     <span />
//                   </div>
//                 </>
//               )}

//               {/* ---------------- STEP 3: details (add / remove) ---------------- */}
//               {step === 3 && pkgData && (
//                 <>
//                   <h2 className="qt-h-title">The following items are included in your {pkgData.name} package</h2>
//                   <p className="qt-h-sub">Customise it your way &ndash; remove what you don't need, add what you want, and see the cost difference instantly.</p>
//                   <div className="qt-howto">
//                     <div className="qt-how"><b>1</b><div><strong>Rooms &amp; items</strong><span>Remove a <u>whole room</u> or single items. Cost is <em>deducted</em>.</span></div></div>
//                     <div className="qt-how"><b>2</b><div><strong>Add-ons</strong><span><span className="qt-d-only">Use the Add-ons panel on the right.</span><span className="qt-m-only">Add-ons are shown below each area.</span> Tap <u>+ Add</u> to <em>add</em> cost.</span></div></div>
//                     <div className="qt-how"><b>3</b><div><strong>Cost difference</strong><span>The top bar shows base, added (+), removed (&minus;) and your total.</span></div></div>
//                   </div>

//                   <div className="qt-rooms-h">
//                     <h3>Rooms &amp; areas in your package</h3>
//                     <p>Not furnishing a room? Remove the whole room here in one tap &ndash; no need to remove its items one by one. Items of each room are listed below.</p>
//                   </div>
//                   <div className="qt-rgrid">
//                     {sections.filter((sec) => incList(sec, pkg).length).map((sec) => {
//                       const off = removedRooms.has(sec.id);
//                       const amt = roomAmt(sec, pkg);
//                       const n = incList(sec, pkg).length;
//                       return (
//                         <div className={`qt-rcard ${off ? "qt-off" : ""}`} key={sec.id}>
//                           <div className="qt-pic"><Icon name="" forceKey={ROOM_ICONS[sec.id] || (sec.id.indexOf("bed") === 0 ? "bed" : "box")} /></div>
//                           <div className="qt-rn">
//                             <strong>{sec.name}</strong>
//                             <span>{n} item{n > 1 ? "s" : ""} &middot; {inr(amt)}</span>
//                           </div>
//                           {off ? (
//                             <button type="button" className="qt-tbtn qt-un" onClick={() => toggleRoom(sec.id)}>Undo &middot; +{inr(amt)}</button>
//                           ) : (
//                             <button type="button" className="qt-tbtn qt-rm" onClick={() => toggleRoom(sec.id)}>Remove room &middot; &minus;{inr(amt)}</button>
//                           )}
//                         </div>
//                       );
//                     })}
//                   </div>

//                   <div className="qt-list-h">
//                     <h3>Items in each room</h3>
//                     <p>Remove individual items, or jump to a room using the tabs below.</p>
//                   </div>
//                   <div className="qt-chipbar" ref={chipbarRef}>
//                     {sections.map((sec) => (
//                       <button
//                         type="button"
//                         key={sec.id}
//                         className={`qt-chip ${sec.id === activeSec ? "qt-on" : ""} ${removedRooms.has(sec.id) ? "qt-gone" : ""}`}
//                         onClick={() => jumpTo(sec.id)}
//                       >
//                         {sec.name}
//                       </button>
//                     ))}
//                   </div>

//                   {sections.map((sec) => {
//                     const inc = incList(sec, pkg);
//                     const opt = optList(sec, pkg);
//                     if (removedRooms.has(sec.id)) {
//                       const amt = roomAmt(sec, pkg);
//                       return (
//                         <section className="qt-dsec" id={"qt-dsec-" + sec.id} key={sec.id}>
//                           <div className="qt-dsec-h"><h3>{sec.name}</h3><span>{inc.length} included &middot; {opt.length} add-ons</span></div>
//                           <div className="qt-rmnotice">
//                             <div>
//                               <b>This room is removed from your quotation.</b><br />
//                               <span>{inr(amt)} has been deducted from your estimate. Its items and add-ons are hidden.</span>
//                             </div>
//                             <button type="button" className="qt-tbtn qt-un" onClick={() => toggleRoom(sec.id)}>Undo &middot; +{inr(amt)}</button>
//                           </div>
//                         </section>
//                       );
//                     }
//                     return (
//                       <section className="qt-dsec" id={"qt-dsec-" + sec.id} key={sec.id}>
//                         <div className="qt-dsec-h"><h3>{sec.name}</h3><span>{inc.length} included &middot; {opt.length} add-ons</span></div>
//                         {inc.length ? (
//                           <div className="qt-irows">
//                             {inc.map((it) => (
//                               <IncludedCard key={it.id} sec={sec} it={it} selected={selected.has(keyOf(sec, it))} onToggle={toggleItem} />
//                             ))}
//                           </div>
//                         ) : (
//                           <div className="qt-empty">No default items in this area. Browse the optional add-ons &rarr;</div>
//                         )}
//                         {opt.length > 0 && (
//                           <div className="qt-inline-addons">
//                             <div className="qt-grp qt-add">Optional add-ons for {sec.name}</div>
//                             <div className="qt-agrid">
//                               {opt.map((it) => (
//                                 <AddonCard key={it.id} sec={sec} it={it} selected={selected.has(keyOf(sec, it))} onToggle={toggleItem} />
//                               ))}
//                             </div>
//                           </div>
//                         )}
//                       </section>
//                     );
//                   })}

//                   <div className="qt-err">{error}</div>
//                   <div className="qt-nav">
//                     <button type="button" className="qt-btn qt-s" onClick={goBack}>&larr; Back</button>
//                     <button type="button" className="qt-btn qt-p" onClick={goNext}>Next &rarr;</button>
//                   </div>
//                 </>
//               )}

//               {/* ---------------- STEP 4: client details ---------------- */}
//               {step === 4 && (
//                 <>
//                   <h2>Your details</h2>
//                   <p className="qt-lead">Your quotation will be prepared with these details.</p>
//                   <div className="qt-two">
//                     <div>
//                       <label className="qt-f">Full name *</label>
//                       <input type="text" value={client.name} autoComplete="name" onChange={(e) => setClient({ ...client, name: e.target.value })} />
//                     </div>
//                     <div>
//                       <label className="qt-f">Mobile number *</label>
//                       <input type="tel" value={client.phone} autoComplete="tel" placeholder="10 digit number" onChange={(e) => setClient({ ...client, phone: e.target.value })} />
//                     </div>
//                   </div>
//                   <label className="qt-f">Email *</label>
//                   <input type="email" value={client.email} autoComplete="email" onChange={(e) => setClient({ ...client, email: e.target.value })} />
//                   <label className="qt-f">Property address *</label>
//                   <textarea value={client.address} onChange={(e) => setClient({ ...client, address: e.target.value })} />
//                   <div className="qt-err">{error}</div>
//                   <div className="qt-nav">
//                     <button type="button" className="qt-btn qt-s" onClick={goBack}>&larr; Back</button>
//                     <button type="button" className="qt-btn qt-g" onClick={submitQuote}>Submit &amp; Get Quotation</button>
//                   </div>
//                 </>
//               )}

//               {/* ---------------- STEP 5: success ---------------- */}
//               {step === 5 && (
//                 <div className="qt-success">
//                   <div className="qt-tick">&#10003;</div>
//                   <h2>Thank you, {client.name}!</h2>
//                   <p className="qt-lead">Your quotation is ready. Our team will contact you shortly.</p>
//                   <div className="qt-qno">Quotation No: {quoteNo}</div>
//                   <div className="qt-disclaimer"><b>Estimate notice:</b> Please note: this is an approximate estimate. The final pricing may be slightly higher or lower depending on accurate room sizing, which our team will verify and confirm with you.</div>
//                   <div className="qt-btns">
//                     <button type="button" className="qt-btn qt-g" onClick={generatePDF}>&#8681; Download Quotation PDF</button>
//                     <button type="button" className="qt-btn qt-s" onClick={restart}>New Quotation</button>
//                   </div>
//                 </div>
//               )}
//             </main>

//             {/* ---------------- add-ons panel (desktop, step 3) ---------------- */}
//             {step === 3 && addonSec && (
//               <aside className="qt-card qt-addons" ref={addonsRef}>
//                 <div className="qt-ap-h">
//                   <div className="qt-ap-k">Optional add-ons for</div>
//                   <h3>{addonSec.name}</h3>
//                   {!removedRooms.has(addonSec.id) && (
//                     <div className="qt-ap-n">
//                       {optList(addonSec, pkg).length} available &middot; {optList(addonSec, pkg).filter((it) => selected.has(keyOf(addonSec, it))).length} added
//                     </div>
//                   )}
//                 </div>
//                 {removedRooms.has(addonSec.id) ? (
//                   <div className="qt-empty">This room is removed from your quotation. Use <b>Undo</b> in the rooms list to bring it back and see its add-ons.</div>
//                 ) : optList(addonSec, pkg).length ? (
//                   <div className="qt-agrid">
//                     {optList(addonSec, pkg).map((it) => (
//                       <AddonCard key={it.id} sec={addonSec} it={it} selected={selected.has(keyOf(addonSec, it))} onToggle={toggleItem} />
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="qt-empty">No add-ons available for this area.</div>
//                 )}
//               </aside>
//             )}

//             {/* ---------------- live estimate (step 2 par hidden) ---------------- */}
//             {!packageStep && (
//               <aside className="qt-card qt-summary">
//                 <h3>Your Estimate</h3>
//                 <div className="qt-srow"><span>Property</span><b>{propertyLabel()}</b></div>
//                 <div className="qt-srow"><span>Carpet area</span><b>{calc.area ? calc.area.toLocaleString("en-IN") + " sqft" : "-"}</b></div>
//                 <div className="qt-srow"><span>Package</span><b>{pkgData ? pkgData.name : "-"}</b></div>
//                 {ready && (
//                   <>
//                     <div className="qt-srow"><span>Base ({calc.area.toLocaleString("en-IN")} x {inr(calc.rate)})</span><b>{inr(calc.base)}</b></div>
//                     {calc.added.length > 0 && (
//                       <>
//                         <div className="qt-srow"><span>Items added ({calc.added.length})</span><b className="qt-plus">+ {inr(calc.addSum)}</b></div>
//                         <div className="qt-chips">{calc.added.map((r) => r.it.name).join(", ")}</div>
//                       </>
//                     )}
//                     {calc.rooms.length > 0 && (
//                       <>
//                         <div className="qt-srow"><span>Rooms removed ({calc.rooms.length})</span><b className="qt-minus">- {inr(calc.roomSum)}</b></div>
//                         <div className="qt-chips">{calc.rooms.map((r) => r.sec.name).join(", ")}</div>
//                       </>
//                     )}
//                     {calc.removed.length > 0 && (
//                       <>
//                         <div className="qt-srow"><span>Items removed ({calc.removed.length})</span><b className="qt-minus">- {inr(calc.remSum)}</b></div>
//                         <div className="qt-chips">{calc.removed.map((r) => r.it.name).join(", ")}</div>
//                       </>
//                     )}
//                   </>
//                 )}
//                 <div className="qt-total"><span>Total Estimate</span><b>{ready ? inr(calc.total) : "-"}</b></div>
//                 <div className="qt-note">Approximate estimate. Final price may vary slightly up or down based on accurate room sizing. {gstNote}</div>
//               </aside>
//             )}
//           </div>
//         )}
//       </div>

//       {pricingState === "ready" && !packageStep && (
//         <div className="qt-mbar">
//           <span>Total Estimate</span>
//           <b>{ready ? inr(calc.total) : "-"}</b>
//         </div>
//       )}
//       </div>
//     </>
//   );
// }












import { useState, useMemo, useEffect, useRef, useCallback } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { PROPERTY_TYPES, PKG_KEYS, buildSections, IC, iconKey, ROOM_ICONS } from "./quotationToolData";
import Header from "../components/Header/header";
import "./QuotationTool.css";
import IMG_BASIC from "../assets/riverstone-residence/riverstone-residence.jpg";
import IMG_STANDARD from "../assets/standard-package.jpeg";

/* =====================================================================
   Dwellora Designs - Instant Quotation Tool
   Needs:  npm install jspdf jspdf-autotable

   NO PRICES LIVE IN THIS FILE. Package inclusions and every item price are
   fetched from the CRM database (GET /api/quote-tool/pricing). The owner
   edits them in Admin > Quotation tool pricing. If the CRM cannot be
   reached the tool shows "Pricing unavailable" + Retry (no fallback prices).
   ===================================================================== */

// local host check (same convention as FurniturePlanner)
const API_BASE_URL = (
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_ADMIN_API_BASE_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      "http://localhost:3005"
    : process.env.REACT_APP_API_BASE_URL || ""
).replace(/\/$/, "");

const PRICING_URL = `${API_BASE_URL}/api/quote-tool/pricing`;
const QUOTATION_SUBMISSION_URL = `${API_BASE_URL}/api/quotation-tool/submissions`;
const PRICING_SYNC_INTERVAL_MS = 60 * 1000;
const imageUrl = (url) => {
  if (!url || /^https?:\/\//i.test(url)) return url;
  return API_BASE_URL + url;
};

const BRAND = "Dwellora Designs";
const TAGLINE = "Interior Design Quotation";
const CONTACT = "dwelloradesigns.com"; // shown in PDF footer
const IMG_PREMIUM =
  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=900&q=80";

// Package images are website assets, never CRM values. Package names, rates and
// availability are still controlled in the CRM; images stay mapped to package code.
const PACKAGE_IMAGES = {
  basic: IMG_BASIC,
  // The CRM package names can change, but these database codes stay fixed.
  // Currently: basic → Basic, premium → Standard, luxury → Premium.
  standard: IMG_STANDARD,
  premium: IMG_STANDARD,
  luxury: IMG_PREMIUM,
};

const STEP_NAMES = ["Property & Area", "Details", "Package", "Your Info"];

const inr = (n) => "\u20B9" + Math.round(n).toLocaleString("en-IN");
const rs = (n) => "Rs. " + Math.round(n).toLocaleString("en-IN");
const keyOf = (sec, it) => sec.id + "." + it.id;

/* Item definitions come from quotationToolData.js; prices come from the CRM.
   An item without a CRM price (or switched to Hidden) is not shown. */
function makeSections(pricing, beds, typeId, packageCode) {
  if (!pricing) return [];
  const big = ["bungalow", "penthouse", "other"].includes(typeId);
  return buildSections(beds, big)
    .map((sec) => ({
      ...sec,
      items: sec.items
        .map((it) => {
          const crm = pricing.items[keyOf(sec, it)];
          if (!crm) return null;
          return {
            ...it,
            name: crm.name || it.name,
            price: Number(crm.prices?.[packageCode] ?? crm.price),
            prices: crm.prices || {},
            image_url: crm.image_url || "",
            inc: Array.isArray(crm.included_in) ? crm.included_in : it.inc,
          };
        })
        .filter(Boolean),
    }))
    .filter((sec) => sec.items.length);
}

function defaultSelection(sections, pkg) {
  const picked = new Set();
  if (!pkg) return picked;
  sections.forEach((sec) =>
    sec.items.forEach((it) => {
      if (it.inc.includes(pkg)) picked.add(keyOf(sec, it));
    })
  );
  return picked;
}

const incList = (sec, pkg) => sec.items.filter((it) => it.inc.includes(pkg));
const optList = (sec, pkg) => sec.items.filter((it) => !it.inc.includes(pkg));
const itemQty = (sec, it) => it.mult || sec.mult || 1;
const itemQtyLabel = (sec, it) => it.multLabel || sec.multLabel || "units";
const itemAmt = (sec, it) => it.price * itemQty(sec, it);
const itemAmtFor = (sec, it, pkg) => Number(it.prices?.[pkg] ?? it.price) * itemQty(sec, it);
const defaultRoomAmt = (sec, pkg) => incList(sec, pkg).reduce((a, it) => a + itemAmtFor(sec, it, pkg), 0);
const packageAmt = (sections, pkg) => sections.reduce((total, sec) => total + defaultRoomAmt(sec, pkg), 0);

function noteText(sec, it) {
  const qty = itemQty(sec, it);
  const parts = [];
  if (it.size) parts.push("Size: " + it.size + " (L x W)");
  if (it.note) parts.push(it.note);
  if (qty > 1) parts.push(qty + " " + itemQtyLabel(sec, it) + " x " + inr(it.price));
  return parts.join(" \u00B7 ");
}

function Icon({ name, forceKey }) {
  const k = forceKey || iconKey(name);
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: IC[k] }}
    />
  );
}

function PackageImage({ src, alt }) {
  const [failed, setFailed] = useState(false);
  return (
    <div className="qt-pimg">
      {src && !failed ? (
        <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <div className="qt-pimg-fb">{alt}</div>
      )}
    </div>
  );
}

function IncludedCard({ sec, it, selected, onToggle }) {
  const amt = itemAmt(sec, it);
  const note = noteText(sec, it);
  return (
    <div className={`qt-icard ${selected ? "" : "qt-off"}`}>
      <div className="qt-pic"><Icon name={it.name} /></div>
      <div className="qt-nm">
        {it.name}
        {note && <small>{note}</small>}
      </div>
      <div className="qt-side">
        <span className="qt-price">{inr(amt)}</span>
        {selected ? (
          <button type="button" className="qt-tbtn qt-rm" onClick={() => onToggle(keyOf(sec, it))}>
            Remove &middot; &minus;{inr(amt)}
          </button>
        ) : (
          <button type="button" className="qt-tbtn qt-un" onClick={() => onToggle(keyOf(sec, it))}>
            Undo &middot; +{inr(amt)}
          </button>
        )}
      </div>
    </div>
  );
}

function AddonCard({ sec, it, selected, onToggle }) {
  const amt = itemAmt(sec, it);
  const note = noteText(sec, it);
  return (
    <div className={`qt-acard ${selected ? "qt-on" : ""}`}>
      <div className="qt-a-img">
        {it.image_url ? <img src={imageUrl(it.image_url)} alt="" loading="lazy" /> : <Icon name={it.name} />}
      </div>
      <div className="qt-a-info">
        <div className="qt-nm">
          {it.name}
          {note && <small>{note}</small>}
        </div>
      </div>
      <div className="qt-a-bot">
        <span className="qt-a-price">{inr(amt)}</span>
        {selected ? (
          <button type="button" className="qt-tbtn qt-un" onClick={() => onToggle(keyOf(sec, it))}>
            &#10003; Added &middot; Undo
          </button>
        ) : (
          <button type="button" className="qt-tbtn qt-ad" onClick={() => onToggle(keyOf(sec, it))}>
            + Add
          </button>
        )}
      </div>
    </div>
  );
}

function PriceBreakdown({ title, amount, items, action, onItem, onRoom }) {
  return (
    <div className="qt-pb-col">
      <h4><span>{title}</span><span>{title === "Added" ? "+" : "\u2212"}{inr(amount)}</span></h4>
      {items.length ? (
        <ul>{items.map((record) => (
          <li key={record.room ? `room-${record.sec.id}` : keyOf(record.sec, record.it)}>
            <span className="qt-l"><b>{record.room ? record.sec.name : record.it.name}</b><small>{record.room ? "Whole room" : record.sec.name}</small></span>
            <span className="qt-a">{title === "Added" ? "+" : "\u2212"}{inr(record.amt)}</span>
            <button type="button" className="qt-pb-undo" onClick={() => record.room ? onRoom(record.sec.id) : onItem(keyOf(record.sec, record.it))}>{action}</button>
          </li>
        ))}</ul>
      ) : <div className="qt-pb-none">Nothing {title === "Added" ? "added" : "removed"} yet.</div>}
    </div>
  );
}

export default function QuotationTool() {
  const [pricing, setPricing] = useState(null);
  const [pricingState, setPricingState] = useState("loading"); // loading | ready | error

  const [step, setStep] = useState(1);
  const [typeId, setTypeId] = useState(null);
  const [otherName, setOtherName] = useState("");
  const [beds, setBeds] = useState(2);
  const [area, setArea] = useState("");
  const [pkg, setPkg] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [touchedItems, setTouchedItems] = useState(new Set());
  const [removedRooms, setRemovedRooms] = useState(new Set());
  const [activeSec, setActiveSec] = useState(null);
  const [client, setClient] = useState({ name: "", phone: "", email: "", address: "" });
  const [quoteNo, setQuoteNo] = useState("");
  const [quoteDate, setQuoteDate] = useState(null);
  const [error, setError] = useState("");
  const [priceBreakdownOpen, setPriceBreakdownOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [emailDelivery, setEmailDelivery] = useState(null);
  const [whatsAppUrl, setWhatsAppUrl] = useState("");
  const chipbarRef = useRef(null);
  const addonsRef = useRef(null);
  const pricingRequestId = useRef(0);

  /* ---------- load prices from the CRM ---------- */
  const loadPricing = useCallback(async ({ silent = false } = {}) => {
    const requestId = ++pricingRequestId.current;
    if (!silent) setPricingState("loading");
    try {
      const response = await fetch(PRICING_URL, { cache: "no-store" });
      const payload = await response.json();
      if (!response.ok || !payload?.success || !payload.data) throw new Error("Pricing unavailable");
      const data = payload.data;
      if (!Array.isArray(data.packages) || !data.packages.length || !data.items) throw new Error("Pricing unavailable");
      if (requestId !== pricingRequestId.current) return;
      setPricing(data);
      setPricingState("ready");
    } catch (err) {
      if (requestId !== pricingRequestId.current) return;
      if (silent) return;
      setPricing(null);
      setPricingState("error");
    }
  }, []);

  useEffect(() => {
    loadPricing();
    const refreshPricing = () => {
      if (document.visibilityState === "hidden") return;
      loadPricing({ silent: true });
    };
    const intervalId = window.setInterval(refreshPricing, PRICING_SYNC_INTERVAL_MS);
    window.addEventListener("focus", refreshPricing);
    document.addEventListener("visibilitychange", refreshPricing);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", refreshPricing);
      document.removeEventListener("visibilitychange", refreshPricing);
    };
  }, [loadPricing]);

  const settings = pricing?.settings || {};
  const minArea = Number(settings.min_area) || 100;
  const validityDays = Number(settings.validity_days) || 15;
  const gstNote = settings.gst_note || "GST extra as applicable.";
  const packages = pricing?.packages || [];
  const pkgData = packages.find((p) => p.code === pkg) || null;

  const sections = useMemo(() => makeSections(pricing, beds, typeId, pkg), [pricing, beds, typeId, pkg]);
  // A whole-room removal must deduct the actual included material value.
  // Do not use the old `room_amount.*` settings here: they were manual
  // overrides and could be saved as values such as Rs. 10/20/30, which made
  // a full room removal deduct an incorrect amount from the quote.
  const roomAmt = (sec, packageCode) => defaultRoomAmt(sec, packageCode);

  const propertyLabel = () => {
    const t = PROPERTY_TYPES.find((p) => p.id === typeId);
    if (!t) return "-";
    if (t.id === "other") return "Other" + (otherName ? " (" + otherName + ")" : "");
    return t.unit ? t.label + " " + t.unit : t.label;
  };

  useEffect(() => {
    const defaultPackage = packages[0];
    if (!defaultPackage) return;
    if (!pkg || !packages.some((entry) => entry.code === pkg)) {
      setPkg(defaultPackage.code);
      setSelected(defaultSelection(makeSections(pricing, beds, typeId, defaultPackage.code), defaultPackage.code));
      setTouchedItems(new Set());
    }
  }, [packages, pkg, pricing, beds, typeId]);

  /* ---------- calculation: included package items + add-ons - removals ---------- */
  const calc = useMemo(() => {
    const areaNum = parseFloat(area) || 0;
    const base = packageAmt(sections, pkg);
    const added = [];
    const removed = [];
    const rooms = [];
    sections.forEach((sec) => {
      if (removedRooms.has(sec.id)) {
        rooms.push({ sec, amt: roomAmt(sec, pkg) });
        return;
      }
      sec.items.forEach((it) => {
        const qty = itemQty(sec, it);
        const rec = { sec, it, qty, amt: it.price * qty };
        const isDefault = it.inc.includes(pkg);
        const isSel = selected.has(keyOf(sec, it));
        if (isSel && !isDefault) added.push(rec);
        if (!isSel && isDefault) removed.push(rec);
      });
    });
    const addSum = added.reduce((a, r) => a + r.amt, 0);
    const remSum = removed.reduce((a, r) => a + r.amt, 0);
    const roomSum = rooms.reduce((a, r) => a + r.amt, 0);
    const total = Math.max(0, base + addSum - remSum - roomSum);
    return { area: areaNum, base, added, removed, rooms, addSum, remSum, roomSum, total };
  }, [sections, selected, removedRooms, pkg, area]);

  const ready = Boolean(pkg && calc.area);
  const removedTotal = calc.remSum + calc.roomSum;
  const totalForPackage = (packageCode) => {
    let total = packageAmt(sections, packageCode);
    sections.forEach((sec) => {
      if (removedRooms.has(sec.id)) {
        total -= defaultRoomAmt(sec, packageCode);
        return;
      }
      
      sec.items.forEach((it) => {
        const key = keyOf(sec, it);
        const isIncluded = it.inc.includes(packageCode);
        const isSelected = touchedItems.has(key) ? selected.has(key) : isIncluded;
        const amount = itemAmtFor(sec, it, packageCode);
        if (isSelected && !isIncluded) total += amount;
        if (!isSelected && isIncluded) total -= amount;
      });
    });
    return Math.max(0, total);
  };

  /* ---------- actions ---------- */
  const chooseType = (t) => {
    const nextBeds = t.id !== "other" ? t.beds : typeId !== "other" ? 2 : beds;
    setTypeId(t.id);
    setBeds(nextBeds);
    setSelected(defaultSelection(makeSections(pricing, nextBeds, t.id, pkg), pkg));
    setTouchedItems(new Set());
    setRemovedRooms(new Set());
    setError("");
  };

  const changeOtherBeds = (value) => {
    const n = Math.min(10, Math.max(1, parseInt(value, 10) || 1));
    setBeds(n);
    setSelected(defaultSelection(makeSections(pricing, n, typeId, pkg), pkg));
    setTouchedItems(new Set());
    setRemovedRooms(new Set());
  };

  const choosePackage = (code) => {
    if (pkg !== code) {
      const nextSections = makeSections(pricing, beds, typeId, code);
      const nextSelected = new Set();
      nextSections.forEach((sec) => sec.items.forEach((it) => {
        const key = keyOf(sec, it);
        if (touchedItems.has(key) ? selected.has(key) : it.inc.includes(code)) nextSelected.add(key);
      }));
      setPkg(code);
      setSelected(nextSelected);
    }
    setError("");
  };

  const toggleItem = (key) => {
    setTouchedItems((current) => new Set([...current, key]));
    setSelected((current) => {
      const next = new Set(current);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const toggleRoom = (id) => {
    const sec = sections.find((s) => s.id === id);
    if (!sec) return;
    const nextRemoved = new Set(removedRooms);
    const nextSelected = new Set(selected);
    if (nextRemoved.has(id)) {
      nextRemoved.delete(id);
      incList(sec, pkg).forEach((it) => nextSelected.add(keyOf(sec, it)));
    } else {
      nextRemoved.add(id);
      sec.items.forEach((it) => nextSelected.delete(keyOf(sec, it)));
    }
    setRemovedRooms(nextRemoved);
    setSelected(nextSelected);
  };

  const jumpTo = (id) => {
    setActiveSec(id);
    if (addonsRef.current) addonsRef.current.scrollTop = 0;
    const target = document.getElementById("qt-dsec-" + id);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goNext = () => {
    if (step === 1) {
      if (!typeId) return setError("Please select a property type.");
      if (typeId === "other" && !otherName.trim()) return setError("Please enter your property type.");
      const a = parseFloat(area);
      if (!a || a < minArea) return setError(`Please enter carpet area (minimum ${minArea} sqft).`);
    }
    if ((step === 2 || step === 3) && !pkg) return setError("Please select a package.");
    setError("");
    setStep(step + 1);
  };

  const goBack = () => {
    setError("");
    setStep(Math.max(1, step - 1));
  };

  const submitQuote = async () => {
    if (submitting) return;
    const phone = client.phone.replace(/\D/g, "").replace(/^91(?=\d{10}$)/, "");
    if (!client.name.trim()) return setError("Please enter your name.");
    if (!/^[6-9]\d{9}$/.test(phone)) return setError("Please enter a valid 10-digit mobile number.");
    if (client.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(client.email.trim())) return setError("Please enter a valid email address.");
    if (client.address.trim().length < 5) return setError("Please enter your property address.");

    const d = new Date();
    const ymd = d.getFullYear().toString() + String(d.getMonth() + 1).padStart(2, "0") + String(d.getDate()).padStart(2, "0");
    const number = "DD-" + ymd + "-" + String(Math.floor(1000 + Math.random() * 9000));
    setSubmitting(true);
    setError("");
    try {
      const { doc, fileName } = buildQuotationPdf({ quoteNumber: number, issuedOn: d });
      const data = new FormData();
      data.append("pdf", doc.output("blob"), fileName);
      data.append("data", JSON.stringify({
        quotationNo: number,
        name: client.name.trim(), phone, email: client.email.trim(),
        property: propertyLabel(), address: client.address.trim(),
        carpetArea: calc.area, packageCode: pkg, packageName: pkgData.name,
        ratePerSqft: 0, baseAmount: calc.base, addedAmount: calc.addSum,
        removedAmount: calc.remSum + calc.roomSum, totalAmount: calc.total,
        details: {
          calculationMode: "package_included_items",
          includedItems: sections.flatMap((sec) => sec.items.filter((it) => it.inc.includes(pkg) && selected.has(keyOf(sec, it)) && !removedRooms.has(sec.id)).map((it) => ({ section: sec.name, item: it.name, amount: itemAmt(sec, it) }))),
          bedrooms: beds,
          removedRooms: calc.rooms.map((r) => ({ room: r.sec.name, amount: r.amt })),
          added: calc.added.map((r) => ({ section: r.sec.name, item: r.it.name, amount: r.amt })),
          removed: calc.removed.map((r) => ({ section: r.sec.name, item: r.it.name, amount: r.amt })),
        },
      }));
      const response = await fetch(QUOTATION_SUBMISSION_URL, { method: "POST", body: data });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.success) throw new Error(result?.message || "Unable to create the quotation. Please try again.");
      if (!result.pdfUrl) throw new Error("Quotation link could not be created. Please try again.");
      const whatsappMessage = `Hello ${client.name.trim()}, your Dwellora quotation (${number}) is ready. Download your quotation PDF here: ${result.pdfUrl}`;
      const url = `https://wa.me/91${phone}?text=${encodeURIComponent(whatsappMessage)}`;
      setWhatsAppUrl(url);
      window.open(url, "_blank", "noopener,noreferrer");
      setQuoteDate(d);
      setQuoteNo(number);
      setEmailDelivery(result.emailDelivery || null);
      setStep(5);
    } catch (submissionError) {
      setError(submissionError.message || "Unable to create the quotation. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const restart = () => {
    setStep(1);
    setTypeId(null);
    setOtherName("");
    setBeds(2);
    setArea("");
    setPkg(null);
    setSelected(new Set());
    setTouchedItems(new Set());
    setRemovedRooms(new Set());
    setClient({ name: "", phone: "", email: "", address: "" });
    setQuoteNo("");
    setQuoteDate(null);
    setError("");
    setPriceBreakdownOpen(false);
    setEmailDelivery(null);
    setWhatsAppUrl("");
  };

  /* ---------- scroll to top on step change ---------- */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [step]);

  /* ---------- details step: keep the active room tab in sync with scrolling ---------- */
  useEffect(() => {
    if (step !== 2 || !sections.length) return undefined;
    let raf = 0;
    const spy = () => {
      raf = 0;
      let current = sections[0].id;
      const title = document.querySelector(".qt-h-title");
      const activationLine = title
        ? title.getBoundingClientRect().bottom + 24
        : 170;
      sections.forEach((sec) => {
        const heading = document.getElementById("qt-dsec-" + sec.id)?.querySelector(".qt-dsec-h");
        if (heading && heading.getBoundingClientRect().top <= activationLine) current = sec.id;
      });
      const reachedPageEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (reachedPageEnd) current = sections[sections.length - 1].id;
      setActiveSec((active) => active === current ? active : current);
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(spy);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    spy();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [step, sections]);

  useEffect(() => {
    const bar = chipbarRef.current;
    if (!bar) return;
    const on = bar.querySelector(".qt-chip.qt-on");
    if (on) bar.scrollTo({ left: on.offsetLeft - bar.clientWidth / 2 + on.offsetWidth / 2, behavior: "smooth" });
    if (addonsRef.current) addonsRef.current.scrollTop = 0;
  }, [activeSec]);

  const addonSec = sections.find((s) => s.id === activeSec) || sections[0];

  /* ---------- PDF ---------- */
  const buildQuotationPdf = ({ quoteNumber = quoteNo, issuedOn = quoteDate } = {}) => {
    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const W = doc.internal.pageSize.getWidth();
    const H = doc.internal.pageSize.getHeight();
    const GOLD = [201, 161, 74], INK = [17, 17, 17], GREY = [245, 245, 245];
    const d = issuedOn || new Date();
    const dateStr = d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

    // Header band
    doc.setFillColor(...INK); doc.rect(0, 0, W, 30, "F");
    doc.setTextColor(255, 255, 255); doc.setFont("times", "bold"); doc.setFontSize(22);
    doc.text(BRAND, 14, 14);
    doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...GOLD);
    doc.text(TAGLINE, 14, 21);
    doc.setTextColor(255, 255, 255); doc.setFontSize(9);
    doc.text("Quotation No: " + quoteNumber, W - 14, 13, { align: "right" });
    doc.text("Date: " + dateStr, W - 14, 19, { align: "right" });
    doc.text("Valid for " + validityDays + " days", W - 14, 25, { align: "right" });

    // Client + project blocks
    doc.setTextColor(...INK);
    let y = 40;
    doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(110, 110, 110);
    doc.text("PREPARED FOR", 14, y); doc.text("PROJECT", W / 2 + 4, y);
    doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...INK);
    const left = [client.name, "Mobile: " + client.phone, "Email: " + client.email]
      .concat(doc.splitTextToSize("Address: " + client.address, W / 2 - 20));
    const right = ["Property: " + propertyLabel(),
      "Carpet area: " + calc.area.toLocaleString("en-IN") + " sqft",
      "Package: " + pkgData.name];
    doc.text(left, 14, y + 6);
    doc.text(doc.splitTextToSize(right.join("\n"), W / 2 - 18), W / 2 + 4, y + 6);
    y += 6 + Math.max(left.length, right.length) * 5 + 4;

    // Package specifications
    autoTable(doc, {
      startY: y, head: [["Package specification - " + pkgData.name, ""]], body: pkgData.specs,
      theme: "grid", margin: { left: 14, right: 14 },
      styles: { fontSize: 8.5, cellPadding: 1.8, lineColor: [228, 228, 228], lineWidth: 0.2, textColor: INK },
      headStyles: { fillColor: GREY, textColor: INK, fontStyle: "bold" },
      columnStyles: { 0: { cellWidth: 55, fontStyle: "bold" } },
    });
    y = doc.lastAutoTable.finalY + 6;

    // Items table
    const body = [];
    sections.forEach((sec) => {
      const rows = [];
      if (removedRooms.has(sec.id)) {
        rows.push(["Entire room removed from scope", "Removed", "- " + rs(roomAmt(sec, pkg))]);
      } else {
        sec.items.forEach((it) => {
          const qty = itemQty(sec, it);
          const amt = it.price * qty;
          const isDef = it.inc.includes(pkg);
          const isSel = selected.has(keyOf(sec, it));
          const nm = it.name + (it.size ? " (" + it.size + ")" : "") + (it.note ? " (" + it.note + ")" : "") + (qty > 1 ? " (x" + qty + " " + itemQtyLabel(sec, it) + ")" : "");
          if (isSel && isDef) rows.push([nm, "Included", "In package"]);
          else if (isSel && !isDef) rows.push([nm, "Added", "+ " + rs(amt)]);
          else if (!isSel && isDef) rows.push([nm, "Removed", "- " + rs(amt)]);
        });
      }
      if (rows.length) {
        body.push([{ content: sec.name, colSpan: 3, styles: { fillColor: GREY, fontStyle: "bold", textColor: INK } }]);
        rows.forEach((r) => body.push(r));
      }
    });
    autoTable(doc, {
      startY: y, head: [["Item", "Status", "Amount"]], body,
      theme: "grid", margin: { left: 14, right: 14 },
      styles: { fontSize: 9, cellPadding: 2.2, lineColor: [228, 228, 228], lineWidth: 0.2, textColor: INK },
      headStyles: { fillColor: INK, textColor: 255 },
      columnStyles: { 0: { cellWidth: "auto" }, 1: { cellWidth: 26 }, 2: { cellWidth: 40, halign: "right" } },
      didParseCell: (data) => {
        if (data.section === "head" && data.column.index === 2) data.cell.styles.halign = "right";
        if (data.section === "body" && data.column.index > 0) {
          const st = data.row.raw[1];
          if (st === "Added") data.cell.styles.fontStyle = "bold";
          if (st === "Removed") data.cell.styles.textColor = [130, 130, 130];
        }
      },
    });

    // Totals
    let ty = doc.lastAutoTable.finalY + 8;
    if (ty > H - 70) { doc.addPage(); ty = 20; }
    const trows = [
      ["Package included items", rs(calc.base)],
      ["Added items (" + calc.added.length + ")", "+ " + rs(calc.addSum)],
      ["Removed items (" + calc.removed.length + ")", "- " + rs(calc.remSum)],
    ];
    if (calc.rooms.length) trows.push(["Removed rooms (" + calc.rooms.length + ")", "- " + rs(calc.roomSum)]);
    trows.push(["TOTAL ESTIMATE", rs(calc.total)]);
    autoTable(doc, {
      startY: ty, body: trows, theme: "plain", margin: { left: W / 2 - 30, right: 14 },
      styles: { fontSize: 10, cellPadding: 2.4, textColor: INK },
      columnStyles: { 0: { cellWidth: "auto" }, 1: { halign: "right", cellWidth: 36 } },
      didParseCell: (data) => {
        if (data.row.index === trows.length - 1) {
          data.cell.styles.fontStyle = "bold"; data.cell.styles.fontSize = 12;
          data.cell.styles.fillColor = GREY;
        }
      },
    });

    // Terms
    let ky = doc.lastAutoTable.finalY + 10;
    if (ky > H - 45) { doc.addPage(); ky = 20; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(...INK);
    doc.text("TERMS & NOTES", 14, ky);
    doc.setFont("helvetica", "normal"); doc.setFontSize(8.5); doc.setTextColor(80, 80, 80);
    const terms = [
      "1. This is an approximate estimate based on the details provided. Final pricing may be slightly higher or lower depending on accurate room sizing, as verified by our team after site measurement.",
      "2. " + gstNote,
      "3. Quotation valid for " + validityDays + " days from the date of issue.",
      "4. Material brands, finishes and specifications will be finalised in the design agreement.",
    ];
    doc.text(doc.splitTextToSize(terms.join("\n"), W - 28), 14, ky + 6);

    // Footer on each page
    const pages = doc.getNumberOfPages();
    for (let i = 1; i <= pages; i++) {
      doc.setPage(i);
      doc.setDrawColor(...GOLD); doc.setLineWidth(0.4); doc.line(14, H - 14, W - 14, H - 14);
      doc.setFontSize(8); doc.setTextColor(120, 120, 120);
      doc.text(BRAND + "  |  " + CONTACT, 14, H - 9);
      doc.text("Page " + i + " of " + pages, W - 14, H - 9, { align: "right" });
    }
    const safe = (client.name || "Client").replace(/[^a-z0-9]+/gi, "_");
    return { doc, fileName: "Dwellora_Quotation_" + safe + "_" + quoteNumber + ".pdf" };
  };

  const generatePDF = () => {
    const { doc, fileName } = buildQuotationPdf();
    doc.save(fileName);
  };

  const wide = step === 2 && pricingState === "ready";
  const packageStep = step === 3;

  return (
    <>
      <Header />
      <div className="qt">
      {step === 2 && (
        <div className="qt-pricebar">
          <div className="qt-pb-in">
            <div className="qt-pb-ctx">
              <div className="qt-pb-brand">Dwellora</div>
              <div className="qt-pb-meta">{propertyLabel()} &middot; {calc.area ? calc.area.toLocaleString("en-IN") + " sqft" : "-"} &middot; {pkgData?.name || "-"}</div>
            </div>
            <div className="qt-pb-stats" aria-label="Price build-up">
              <div className="qt-pb-stat"><span>{pkgData?.name || "Package"}<em> package</em></span><b>{ready ? inr(calc.base) : "-"}</b></div><div className="qt-pb-op">+</div>
              <div className="qt-pb-stat"><span>Added<em> ({calc.added.length})</em></span><b>{ready ? inr(calc.addSum) : "-"}</b></div><div className="qt-pb-op">&minus;</div>
              <div className="qt-pb-stat qt-rem"><span>Removed<em> ({calc.removed.length + calc.rooms.length})</em></span><b>{ready ? inr(removedTotal) : "-"}</b></div><div className="qt-pb-op qt-eq">=</div>
            </div>
            <div className="qt-pb-total">
              <div className="qt-pb-tot"><span>Total<em> estimate</em></span><b>{ready ? inr(calc.total) : "-"}</b></div>
              <button type="button" className="qt-pb-btn" onClick={() => setPriceBreakdownOpen((open) => !open)} aria-expanded={priceBreakdownOpen}>Breakdown <i>&#9662;</i></button>
            </div>
            {priceBreakdownOpen && (
              <div className="qt-pb-drop"><div className="qt-pb-drop-in">
                <p className="qt-pb-eq"><b>{pkgData?.name || "-"}</b> included items = <b>{inr(calc.base)}</b></p>
                <div className="qt-pb-cols">
                  <PriceBreakdown title="Added" amount={calc.addSum} items={calc.added} action="Undo" onItem={toggleItem} />
                  <PriceBreakdown title="Removed" amount={removedTotal} items={[...calc.rooms.map((r) => ({ ...r, room: true })), ...calc.removed]} action="Restore" onItem={toggleItem} onRoom={toggleRoom} />
                </div>
                <div className="qt-pb-foot">Approximate estimate. Final price may vary slightly based on accurate room sizing. {gstNote}</div>
              </div></div>
            )}
          </div>
        </div>
      )}
      <div className={`qt-wrap ${wide ? "qt-wide" : ""}`}>
        <header className="qt-top">
          <div className="qt-pagehead">
            <h1 className="qt-ptitle">Get Your Instant Quotation</h1>
            <p className="qt-ptagline">Free estimate &middot; Takes 2 minutes &middot; No obligation</p>
          </div>
        </header>

        <div className="qt-progress">
          {STEP_NAMES.map((name, i) => {
            const k = i + 1;
            const cls = step > 4 || k < step ? "qt-done" : k === step ? "qt-now" : "";
            return (
              <div className={`qt-pstep ${cls}`} key={name}>
                <i />
                {k}. {name}
              </div>
            );
          })}
        </div>

        {pricingState !== "ready" && (
          <div className="qt-grid">
            <main className="qt-card">
              {pricingState === "loading" && (
                <>
                  <h2>Loading prices&hellip;</h2>
                  <p className="qt-lead">Please wait a moment while we fetch the latest rates.</p>
                </>
              )}
              {pricingState === "error" && (
                <>
                  <h2>Pricing unavailable</h2>
                  <p className="qt-lead">We could not load the latest prices right now. Please check your connection and try again.</p>
                  <button type="button" className="qt-btn qt-p" onClick={loadPricing}>Retry</button>
                </>
              )}
            </main>
          </div>
        )}

        {pricingState === "ready" && (
          <div className={`qt-grid ${wide ? "qt-g3" : ""} ${packageStep ? "qt-g1" : ""}`}>
            <main className="qt-card">
              {/* ---------------- STEP 1: property & area ---------------- */}
              {step === 1 && (
                <>
                  <h2>Your property</h2>
                  <p className="qt-lead">Choose your property type and enter the carpet area.</p>
                  <label className="qt-f" style={{ marginTop: 0 }}>1. Choose your property type</label>
                  <div className="qt-opts">
                    {PROPERTY_TYPES.map((p) => (
                      <button
                        type="button"
                        key={p.id}
                        className={`qt-opt ${typeId === p.id ? "qt-sel" : ""}`}
                        onClick={() => chooseType(p)}
                      >
                        <b>{p.label}</b>
                        {p.unit && <span className="qt-u">{p.unit}</span>}
                        {p.id === "other" && <small>Specify below</small>}
                      </button>
                    ))}
                  </div>
                  {typeId === "other" && (
                    <div className="qt-two">
                      <div>
                        <label className="qt-f">Property type (e.g. Villa, Duplex, Office)</label>
                        <input type="text" value={otherName} placeholder="Type property name" onChange={(e) => setOtherName(e.target.value)} />
                      </div>
                      <div>
                        <label className="qt-f">Number of bedrooms</label>
                        <input type="number" min="1" max="10" value={beds} onChange={(e) => changeOtherBeds(e.target.value)} />
                      </div>
                    </div>
                  )}
                  <label className="qt-f" style={{ marginTop: 24 }}>2. Carpet area (sqft)</label>
                  <input type="number" min={minArea} inputMode="numeric" value={area} placeholder="e.g. 1200" onChange={(e) => setArea(e.target.value)} />
                  <div className="qt-hint">Minimum {minArea} sqft. Exact area will be confirmed after site measurement.</div>
                  <div className="qt-err">{error}</div>
                  <div className="qt-nav qt-nav-center">
                    <button type="button" className="qt-btn qt-p" onClick={goNext}>Next &rarr;</button>
                  </div>
                </>
              )}

              {/* ---------------- STEP 3: package ---------------- */}
              {step === 3 && (
                <>
                  <h2>Upgrade Your Plan</h2>
                  <p className="qt-lead">Compare package totals and choose the plan that suits you best.</p>
                  <div className="qt-pkgs">
                    {packages.map((p) => (
                      <article
                        key={p.code}
                        className={`qt-pkg ${pkg === p.code ? "qt-sel" : ""}`}
                      >
                        {Boolean(p.popular) && <span className="qt-badge">Most popular</span>}
                        <PackageImage src={p.image_url || p.image || PACKAGE_IMAGES[p.code]} alt={p.name} />
                        <h3 className="qt-pill">{p.name}</h3>
                        <small className="qt-ptag">{p.tag}</small>
                        <dl className="qt-specs">
                          {(p.specs || []).map((spec) => (
                            <div key={spec[0]}>
                              <dt>{spec[0]}</dt>
                              <dd>{spec[1]}</dd>
                            </div>
                          ))}
                        </dl>
                        <div className="qt-ptotal">
                          <div className="qt-ptotal-row"><span>Your total with this plan</span><b>{inr(totalForPackage(p.code))}</b></div>
                        </div>
                        <button type="button" className="qt-pselect" onClick={() => choosePackage(p.code)}>
                          {pkg === p.code ? p.name + " selected \u2713" : "Select " + p.name}
                        </button>
                      </article>
                    ))}
                  </div>
                  <div className="qt-pnote">Final scope is confirmed after site measurement. Add-ons and removals update the package BOQ separately.</div>
                  <div className="qt-err">{error}</div>
                  <div className="qt-nav">
                    <button type="button" className="qt-btn qt-s" onClick={goBack}>&larr; Back</button>
                    <button type="button" className="qt-btn qt-p" onClick={goNext}>Next &rarr;</button>
                  </div>
                </>
              )}

              {/* ---------------- STEP 2: details (add / remove) ---------------- */}
              {step === 2 && pkgData && (
                <>
                  <h2 className="qt-h-title">The following items are included in your {pkgData.name} package</h2>
                  
                  {/* <p className="qt-h-sub">Customise it your way &ndash; remove what you don't need, add what you want, and see the cost difference instantly.</p> */}

                  {/* <div className="qt-howto">
                    <div className="qt-how"><b>1</b><div><strong>Rooms &amp; items</strong><span>Remove a <u>whole room</u> or single items. Cost is <em>deducted</em>.</span></div></div>
                    <div className="qt-how"><b>2</b><div><strong>Add-ons</strong><span><span className="qt-d-only">Use the Add-ons panel on the right.</span><span className="qt-m-only">Add-ons are shown below each area.</span> Tap <u>+ Add</u> to <em>add</em> cost.</span></div></div>
                    <div className="qt-how"><b>3</b><div><strong>Cost difference</strong><span>The top bar shows base, added (+), removed (&minus;) and your total.</span></div></div>
                  </div> */}

                  {/* <div className="qt-rooms-h">
                    <h3>Rooms &amp; areas in your package</h3>
                    <p>Not furnishing a room? Remove the whole room here in one tap &ndash; no need to remove its items one by one. Items of each room are listed below.</p>
                  </div> */}

                  <div className="qt-rgrid">
                    {sections.filter((sec) => incList(sec, pkg).length).map((sec) => {
                      const off = removedRooms.has(sec.id);
                      const amt = roomAmt(sec, pkg);
                      const n = incList(sec, pkg).length;
                      return (
                        <div className={`qt-rcard ${off ? "qt-off" : ""}`} key={sec.id}>
                          <div className="qt-pic"><Icon name="" forceKey={ROOM_ICONS[sec.id] || (sec.id.indexOf("bed") === 0 ? "bed" : "box")} /></div>
                          <div className="qt-rn">
                            <strong>{sec.name}</strong>
                            <span>{n} item{n > 1 ? "s" : ""} &middot; {inr(amt)}</span>
                          </div>
                          {off ? (
                            <button type="button" className="qt-tbtn qt-un" onClick={() => toggleRoom(sec.id)}>Undo &middot; +{inr(amt)}</button>
                          ) : (
                            <button type="button" className="qt-tbtn qt-rm" onClick={() => toggleRoom(sec.id)}>Remove room &middot; &minus;{inr(amt)}</button>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <div className="qt-list-h">
                    <h3>Items in each room</h3>
                    <p>Remove individual items, or jump to a room using the tabs below.</p>
                  </div>
                  <div className="qt-chipbar" ref={chipbarRef}>
                    {sections.map((sec) => (
                      <button
                        type="button"
                        key={sec.id}
                        className={`qt-chip ${sec.id === activeSec ? "qt-on" : ""} ${removedRooms.has(sec.id) ? "qt-gone" : ""}`}
                        onClick={() => jumpTo(sec.id)}
                      >
                        {sec.name}
                      </button>
                    ))}
                  </div>

                  {sections.map((sec) => {
                    const inc = incList(sec, pkg);
                    const opt = optList(sec, pkg);
                    const selectedAddons = opt.filter((it) => selected.has(keyOf(sec, it)));
                    if (removedRooms.has(sec.id)) {
                      const amt = roomAmt(sec, pkg);
                      return (
                        <section className="qt-dsec" id={"qt-dsec-" + sec.id} key={sec.id}>
                          <div className="qt-dsec-h"><h3>{sec.name}</h3><span>{inc.length} included &middot; {opt.length} add-ons</span></div>
                          <div className="qt-rmnotice">
                            <div>
                              <b>This room is removed from your quotation.</b><br />
                              <span>{inr(amt)} has been deducted from your estimate. Its items and add-ons are hidden.</span>
                            </div>
                            <button type="button" className="qt-tbtn qt-un" onClick={() => toggleRoom(sec.id)}>Undo &middot; +{inr(amt)}</button>
                          </div>
                        </section>
                      );
                    }
                    return (
                      <section className="qt-dsec" id={"qt-dsec-" + sec.id} key={sec.id}>
                        <div className="qt-dsec-h"><h3>{sec.name}</h3><span>{inc.length} included &middot; {opt.length} add-ons</span></div>
                        {inc.length ? (
                          <div className="qt-irows">
                            {inc.map((it) => (
                              <IncludedCard key={it.id} sec={sec} it={it} selected={selected.has(keyOf(sec, it))} onToggle={toggleItem} />
                            ))}
                          </div>
                        ) : (
                          <div className="qt-empty">No default items in this area. Choose an add-on to include it in your quotation.</div>
                        )}
                        {selectedAddons.length > 0 && (
                          <div className="qt-added-inline">
                            <div className="qt-grp qt-added">Added to your quotation ({selectedAddons.length})</div>
                            <div className="qt-agrid">
                              {selectedAddons.map((it) => (
                                <AddonCard key={it.id} sec={sec} it={it} selected={true} onToggle={toggleItem} />
                              ))}
                            </div>
                          </div>
                        )}
                        {opt.length > 0 && (
                          <div className="qt-inline-addons">
                            <div className="qt-grp qt-add">Optional add-ons for {sec.name}</div>
                            <div className="qt-agrid">
                              {opt.map((it) => (
                                <AddonCard key={it.id} sec={sec} it={it} selected={selected.has(keyOf(sec, it))} onToggle={toggleItem} />
                              ))}
                            </div>
                          </div>
                        )}
                      </section>
                    );
                  })}

                  <div className="qt-err">{error}</div>
                  <div className="qt-nav">
                    <button type="button" className="qt-btn qt-s" onClick={goBack}>&larr; Back</button>
                    <button type="button" className="qt-btn qt-p" onClick={goNext}>Next &rarr;</button>
                  </div>
                </>
              )}

              {/* ---------------- STEP 4: client details ---------------- */}
              {step === 4 && (
                <>
                  <h2>Your details</h2>
                  <p className="qt-lead">Your quotation will be prepared with these details.</p>
                  <div className="qt-two">
                    <div>
                      <label className="qt-f">Full name *</label>
                      <input type="text" value={client.name} autoComplete="name" onChange={(e) => setClient({ ...client, name: e.target.value })} />
                    </div>
                    <div>
                      <label className="qt-f">Mobile number *</label>
                      <input type="tel" value={client.phone} autoComplete="tel" placeholder="10 digit number" onChange={(e) => setClient({ ...client, phone: e.target.value })} />
                    </div>
                  </div>
                  <label className="qt-f">Email (optional)</label>
                  <input type="email" value={client.email} autoComplete="email" onChange={(e) => setClient({ ...client, email: e.target.value })} />
                  <label className="qt-f">Property address *</label>
                  <textarea value={client.address} onChange={(e) => setClient({ ...client, address: e.target.value })} />
                  <div className="qt-err">{error}</div>
                  <div className="qt-nav">
                    <button type="button" className="qt-btn qt-s" onClick={goBack}>&larr; Back</button>
                    <button type="button" className="qt-btn qt-g" onClick={submitQuote} disabled={submitting}>{submitting ? "Creating quotation…" : "Submit & Get Quotation"}</button>
                  </div>
                </>
              )}

              {/* ---------------- STEP 5: success ---------------- */}
              {step === 5 && (
                <div className="qt-success">
                  <div className="qt-tick">&#10003;</div>
                  <h2>Thank you, {client.name}!</h2>
                  <p className="qt-lead">Your quotation is ready. WhatsApp has opened with a download link for your PDF—just tap Send.</p>
                  {emailDelivery && !emailDelivery.owner && <p className="qt-lead">Your quotation was saved, but the team email delivery is pending.</p>}
                  <div className="qt-qno">Quotation No: {quoteNo}</div>
                  <div className="qt-disclaimer"><b>Estimate notice:</b> Please note: this is an approximate estimate. The final pricing may be slightly higher or lower depending on accurate room sizing, which our team will verify and confirm with you.</div>
                  <div className="qt-btns">
                    <button type="button" className="qt-btn qt-g" onClick={generatePDF}>&#8681; Download Quotation PDF</button>
                    {whatsAppUrl && <button type="button" className="qt-btn qt-g" onClick={() => window.open(whatsAppUrl, "_blank", "noopener,noreferrer")}>WhatsApp</button>}
                    <button type="button" className="qt-btn qt-s" onClick={restart}>New Quotation</button>
                  </div>
                </div>
              )}
            </main>

            {/* ---------------- add-ons panel (desktop, step 2) ---------------- */}
            {step === 2 && addonSec && (
              <aside className="qt-card qt-addons" ref={addonsRef}>
                <div className="qt-ap-h">
                  <div className="qt-ap-k">Optional add-ons for</div>
                  <h3>{addonSec.name}</h3>
                  {!removedRooms.has(addonSec.id) && (
                    <div className="qt-ap-n">
                      {optList(addonSec, pkg).length} available &middot; {optList(addonSec, pkg).filter((it) => selected.has(keyOf(addonSec, it))).length} added
                    </div>
                  )}
                </div>
                {removedRooms.has(addonSec.id) ? (
                  <div className="qt-empty">This room is removed from your quotation. Use <b>Undo</b> in the rooms list to bring it back and see its add-ons.</div>
                ) : optList(addonSec, pkg).length ? (
                  <div className="qt-agrid">
                    {optList(addonSec, pkg).map((it) => (
                      <AddonCard key={it.id} sec={addonSec} it={it} selected={selected.has(keyOf(addonSec, it))} onToggle={toggleItem} />
                    ))}
                  </div>
                ) : (
                  <div className="qt-empty">No add-ons available for this area.</div>
                )}
              </aside>
            )}

            {/* ---------------- live estimate (package selection par hidden) ---------------- */}
            {!packageStep && (
              <aside className="qt-card qt-summary">
                <h3>Your Estimate</h3>
                <div className="qt-srow"><span>Property</span><b>{propertyLabel()}</b></div>
                <div className="qt-srow"><span>Carpet area</span><b>{calc.area ? calc.area.toLocaleString("en-IN") + " sqft" : "-"}</b></div>
                <div className="qt-srow"><span>Package</span><b>{pkgData ? pkgData.name : "-"}</b></div>
                {ready && (
                  <>
                    <div className="qt-srow"><span>Package included items</span><b>{inr(calc.base)}</b></div>
                    {calc.added.length > 0 && (
                      <>
                        <div className="qt-srow"><span>Items added ({calc.added.length})</span><b className="qt-plus">+ {inr(calc.addSum)}</b></div>
                        <div className="qt-chips">{calc.added.map((r) => r.it.name).join(", ")}</div>
                      </>
                    )}
                    {calc.rooms.length > 0 && (
                      <>
                        <div className="qt-srow"><span>Rooms removed ({calc.rooms.length})</span><b className="qt-minus">- {inr(calc.roomSum)}</b></div>
                        <div className="qt-chips">{calc.rooms.map((r) => r.sec.name).join(", ")}</div>
                      </>
                    )}
                    {calc.removed.length > 0 && (
                      <>
                        <div className="qt-srow"><span>Items removed ({calc.removed.length})</span><b className="qt-minus">- {inr(calc.remSum)}</b></div>
                        <div className="qt-chips">{calc.removed.map((r) => r.it.name).join(", ")}</div>
                      </>
                    )}
                  </>
                )}
                <div className="qt-total"><span>Total Estimate</span><b>{ready ? inr(calc.total) : "-"}</b></div>
                <div className="qt-note">Approximate estimate. Final price may vary slightly up or down based on accurate room sizing. {gstNote}</div>
              </aside>
            )}
          </div>
        )}
      </div>

      {pricingState === "ready" && !packageStep && (
        <div className="qt-mbar">
          <span>Total Estimate</span>
          <b>{ready ? inr(calc.total) : "-"}</b>
        </div>
      )}
      </div>
    </>
  );
}
